import { SettingsButton } from 'components/CantileverButton'
import { PageHeaderWithIcon } from 'components/PageHeaderWithIcon'
import { EXPLORER_HEADER_COLOR } from 'features/drilldown/colors'
import { PieChart } from 'lucide-react'
import { FC } from 'react'
import styled from 'styled-components'
import CantileverTheme from 'styles/cantileverTheme'

const APP_TITLE = 'Explorer'
const LOW_OPACITY_PURPLE_500 = 'rgba(90,81,177,0.2)'

const OuterHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-right: 10px;
`

const InnerHeaderContainer = styled.div`
  width: 100%;
`

type DrilldownHeaderProps = {
  handleSettingsClick?: () => void
  explorationTitle?: string
}

const DrilldownHeader: FC<DrilldownHeaderProps> = ({
  handleSettingsClick,
  explorationTitle,
}) => {
  return (
    <OuterHeaderContainer style={{ backgroundColor: EXPLORER_HEADER_COLOR }}>
      <InnerHeaderContainer>
        <PageHeaderWithIcon
          title={APP_TITLE}
          subtitle={explorationTitle}
          icon={<PieChart color={CantileverTheme.colors.purple['300']} />}
          iconBackgroundColor={LOW_OPACITY_PURPLE_500}
          trailingContent={
            <SettingsButton title='Settings' onClick={handleSettingsClick} />
          }></PageHeaderWithIcon>
      </InnerHeaderContainer>
    </OuterHeaderContainer>
  )
}

export default DrilldownHeader
